import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogTitle,
  } from "../../../ui/AlertDialog/AlertDialog";
  import { t } from "i18next";
  import React, { useEffect } from "react";
  import { useFetch } from "../../../hooks/useFetch";
  import { Button } from "../../../ui/Button";
  import { useAppStore } from "../../../stores/RootStore";
  import { useNavigate, useOutletContext } from "react-router-dom";
  import { ScreenType, UserCompact } from "../../../types/types";
  import { useScreenStore } from "../../../stores/ScreenStore";
  
  type Props = {
    isDeleteOpen: boolean;
    closeModal: Function;
  };
  
  const MonitorDelete = ({ isDeleteOpen, closeModal }: Props) => {
    const navigate = useNavigate();
    const {screens, setScreens} = useAppStore()
    const {monitor, resetStore} = useScreenStore()
    const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] = useFetch(
      `/directories/screens/${monitor?.id}`
    );
  
    const onDelete = () => {
      doFetchItemDelete({
        method: "DELETE",
      });
    };
  
    useEffect(() => {
      if (deleteResponse) {
        deleteItem();
        navigate("/monitoring");
        closeModal();
      }
    }, [deleteResponse]);
  
    const deleteItem = () => {
      setScreens(screens?.filter((screen) => screen.id != monitor?.id)!);
      resetStore()
    };
  
    const openStateChange = () => {
      if (isDeleteOpen) closeModal();
    };
  
    return (
      <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
        <AlertDialogContent style={{ maxWidth: 450 }}>
          <AlertDialogTitle>Удалить экран</AlertDialogTitle>
          <AlertDialogDescription>Вы уверены, что хотите удалить экран?</AlertDialogDescription>
  
          <div className="flex justify-between mt-4">
            <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
              {t("delete")}
            </Button>
            <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
          </div>
        </AlertDialogContent>
      </AlertDialog>
    );
  };
  
  export default MonitorDelete;
  